import axios from './axios';

export const invitationValidate = () => {
  return axios
    .post<{
      smsOtpChallengeId: string;
      fullName: string;
      legalName: string;
    }>('/merchant/flows/ksa/invitation/validate')
    .then((res) => res.data);
};

export const validateSmsOtp = (params: { challengeId: string; smsOtpCode: string }) => {
  return axios
    .post<{ existingApplicationUid?: string; existingCompanyLegalName?: string }>(
      '/merchant/flows/ksa/invitation/smsotp',
      params
    )
    .then((res) => res.data);
};

export const acceptInvitation = () => {
  return axios
    .post<{ applicationUid?: string }>('/merchant/flows/ksa/invitation/accept')
    .then((res) => res.data);
};

export const getInvitationName = () => {
  return axios.get('/merchant/flows/ksa/invitation/findUserName').then((res) => res.data);
};
